import { useWeb3React } from '@web3-react/core';
import { useEffect, useState } from 'react';
import { SwapStatus } from '../../types/enums';
import { formatToISwap, Metadatas } from '../../utils/swap';
import { fetchAllTokensMetadata } from '../../services/swap';
import { ISwap } from '../../types/swap';
import { getNFTsMetadata } from '../../services/OpenSea/getNFTsMetadata';
import { useSwapHistory } from './useSwapHistory';

interface SwapsList {
  loading: boolean;
  error?: string;
  data: ISwap[];
}

export const useSwaps = (statuses: SwapStatus[], last = 50): SwapsList => {
  const [metadatas, setMetadatas] = useState<Metadatas>({});
  const [OSmetadatas, setOSMetadatas] = useState({});
  const [metadataLoading, setMetadataLoading] = useState(false);
  const { account, chainId } = useWeb3React();

  const { loading, error, data: allSwaps } = useSwapHistory(last, statuses);
  useEffect(() => {
    if (allSwaps) {
      setMetadataLoading(true);

      // Load metadata from OpenSea for each token address used in the swap
      getNFTsMetadata(allSwaps, chainId).then((nftMetadatas) => {
        setOSMetadatas(nftMetadatas);
        setMetadataLoading(false);
      });

      // Load metadata from tokenUri for each token address used in swap
      fetchAllTokensMetadata(allSwaps).then((nftMetadatas) => {
        setMetadatas(nftMetadatas);
        setMetadataLoading(false);
      });
    }
  }, [allSwaps && allSwaps.length]);

  const fullData: ISwap[] = allSwaps?.map((swap) => formatToISwap(swap, metadatas, OSmetadatas, account)) || [];

  return {
    loading: loading || metadataLoading,
    error,
    data: fullData,
  };
};
